// Products shown in the Zodiac launcher (same order as the home page).
import { baseBitcoinYayURL, baseNewCEXURL } from "../../services/api";

import bitcoinYayIconDark from "../../assets/indexxNewIcons/bitcoinyayLogo.webp";
import cryptoTreasuryIconDark from "../../assets/indexxNewIcons/CryptoTreasuryLogo.webp";
import emmmIconDark from "../../assets/indexxNewIcons/EmmmLogo.webp";
import exchangeIconDark from "../../assets/indexxNewIcons/ExchangeLogo.webp";
import fantasyLottoLogo from "../../assets/updated/homePage/fantasyLottoLogo.png";
import indexxPayLogo from "../../assets/updated/homePage/indexxPayLogo.png";
import indexxWalletLogo from "../../assets/updated/homePage/indexxWalletLogo.png";
import jacksAiLogo from "../../assets/updated/homePage/jacksAiLogo.png";
import reHumanLabLogo from "../../assets/updated/homePage/reHumanLabLogo.png";
import reHumanLabLogoDark from "../../assets/updated/homePage/reHumanLabLogoDark.png";
import shoperPalLogo from "../../assets/updated/homePage/shoperPalLogo.png";
import usdxxIconDark from "../../assets/indexxNewIcons/UsdxxLogo.webp";
import wallstreetIconDark from "../../assets/indexxNewIcons/wallstreetLogo.webp";
import xTokensIconDark from "../../assets/indexxNewIcons/XCryptoLogo.webp";
import xxEmailLogo from "../../assets/updated/homePage/xxEmailLogo.png";
import yaysAppIconDark from "../../assets/indexxNewIcons/YaysAppLogo.webp";

export type LauncherProduct = {
  id: string;
  name: string;
  url: () => string;
  dark: string;
  light: string;
  /** Extra CSS filter for the light-mode icon (e.g. invert a white logo). */
  lightFilter?: string;
};

export const LAUNCHER_PRODUCTS: LauncherProduct[] = [
  { id: "bitcoin-yay", name: "Bitcoin Yay", url: () => baseBitcoinYayURL, dark: bitcoinYayIconDark, light: bitcoinYayIconDark },
  { id: "crypto-treasury", name: "Crypto Treasury", url: () => "https://cex.indexx.ai/crypto-treasury", dark: cryptoTreasuryIconDark, light: cryptoTreasuryIconDark },
  { id: "emmm", name: "Eeny Meeny Miny Moe", url: () => "https://eenymeenyminymoe.io/", dark: emmmIconDark, light: emmmIconDark },
  { id: "exchange", name: "Exchange", url: () => baseNewCEXURL, dark: exchangeIconDark, light: exchangeIconDark },
  { id: "fantasy-lotto", name: "Fantasy Lotto", url: () => "https://lotto.indexx.ai/", dark: fantasyLottoLogo, light: fantasyLottoLogo },
  { id: "indexx-pay", name: "Indexx Pay", url: () => "https://pay.indexx.ai/", dark: indexxPayLogo, light: indexxPayLogo },
  { id: "indexx-wallet", name: "Indexx Wallet", url: () => "https://wallet.indexx.ai/", dark: indexxWalletLogo, light: indexxWalletLogo },
  { id: "jacks-ai", name: "Jack's AI", url: () => "http://jackai.si/", dark: jacksAiLogo, light: jacksAiLogo },
  { id: "rehumen-lab", name: "ReHumen Lab", url: () => "https://rehumenlab.com/", dark: reHumanLabLogoDark, light: reHumanLabLogo },
  { id: "shoperpal", name: "ShoperPal", url: () => "https://test.shoperpal.com/", dark: shoperPalLogo, light: shoperPalLogo },
  { id: "usdxx", name: "USDXX", url: () => "https://usdxxlynx.com", dark: usdxxIconDark, light: usdxxIconDark },
  { id: "wallstreet", name: "Wallstreet", url: () => "https://wallstreet.indexx.ai/", dark: wallstreetIconDark, light: wallstreetIconDark, lightFilter: "invert(1)" },
  { id: "xtokens", name: "xTokens", url: () => "/xtokens", dark: xTokensIconDark, light: xTokensIconDark },
  { id: "xxemail", name: "XXEmail", url: () => "https://test.xxemail.com/", dark: xxEmailLogo, light: xxEmailLogo },
  { id: "yaysapp", name: "YaysApp", url: () => "https://web.yaysapp.com", dark: yaysAppIconDark, light: yaysAppIconDark },
];
